import { talkToServer } from "@helpers/servercomms";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getFromServerTopic } from "../../utility/slice";

const SLICE = "contacts";

const getFromServer = (action) => getFromServerTopic({ topic: SLICE, action });

export const getAllContacts = getFromServer("getAllContacts");

export const getAllActiveContacts = getFromServer("getAllActiveContacts");

export const getContactById = createAsyncThunk(
  "getContactById",
  async (options) => {
    const request = {
      context: {
        topic: "contacts",
        action: "getContactById",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response?.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const slice = createSlice({
  name: SLICE,
  initialState: {
    activeContacts: [],
    contacts: {},
  },
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getAllContacts.fulfilled, (state, action) => {
        state.contacts = action.payload.response;
      })
      .addCase(getAllActiveContacts.fulfilled, (state, action) => {
        state.activeContacts = action.payload.response;
      })
      .addCase(getContactById.fulfilled, (state, action) => {
        const response = action.payload?.response;
        if (response?.rc !== "OK") return;

        const { result } = response.payload;
        state.contacts[result.contact_id] = result;
      }),
});

export default slice.reducer;
